import React from 'react';

export default class NotFound extends React.Component {
    render() {
        return (
            <div className="row box-error">

                <div className="col-lg-4 col-lg-offset-4 col-md-6 col-md-offset-3">

                    <h1>Oops! You are lost.</h1>
                    <p>The page you are looking for was not found.</p>

                </div>

            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./app/pages/NotFound.js